import { gql } from "graphql-tag";

export const ImportListMutation = gql`
  mutation ImportListCSVMutation($id: ID!, $csv: String!) {
    importInterestList(id: $id, csv: $csv) {
      success
    }
  }
`;

export const InterestListsQuery = gql`
  query InterestListsWithOrgQuery {
    interestLists {
      id
      name

      organization {
        id
        name
      }
    }
  }
`;
